import createVueApp from '@phoenix/createVueApp';
import Store from '@phoenix/components/Store';
import OpeningExceptions from '../components/store/OpeningExceptions.vue';

Object.assign(window, {
  Store,
});

const element = document.querySelector('#phoenix-store-opening-exceptions');

if (element) {
  const app = createVueApp({}, true);
  app.component('OpeningExceptions', OpeningExceptions);
  app.mount(element);
}
